import Free from './Free.js';

export default class Utils {
  static stringifyOpts(opts) {
    let rv = {};
    for (let k in opts) {
      rv[k] = ''+opts[k];
    }
    return rv
  }

  static priceLabel(currency, price, type) {
    if (Free.ByType[type]) {
        return "FREE!";
    }
    switch (currency.toLowerCase()) {
      default:
      case 'usd':
        return '$' + price/100;
      case 'eur':
        return '' + price/100 + '€';
    }
  }

  // returns true if the capacities do not include
  // every capacity of the given ones.
  static hasNoneCapacities(capacities, names) {
    if (!capacities || capacities.length === 0) { return true; }

    if (!names) { return true; }
    for (let i = 0; i < names.length; i++) {
      if (Utils.hasCapacity(capacities, names[i])) {
        return false;
      }
    }
    return true;
  }

  static hasCapacities(capacities, names) {
    if (!capacities || capacities.length === 0) {
      return false;
    }
    if (!names) { return true; }

    for (let i = 0; i < names.length; i++) {
      if (!Utils.hasCapacity(capacities, names[i])) {
        return false;
      }
    }
    return true;
  }

  static hasCapacity(capacities, name) {
    if (!capacities || capacities.length === 0) {
      return false;
    }
    for (let i = 0; i < capacities.length; i++) {
      if (capacities[i] === name) {
        return true;
      }
    }
    return false;
  }

  // sameCapacities returns true if all capacities
  // in left exist in right.
  static sameCapacities(left, right) {
    if (!left || !right) {
      console.log("warning: null capacities provided to sameCapacities");
      return
    }

    if (left.length !== right.length) {
      return false;
    }

    for (let i = 0; i < right.length; i++) {
      let fnd = false;
      for (let j = 0; j < left.length; j++) {
        if (right[i] === left[i]) {
          fnd = true;
          break;
        }
      }

      if (!fnd) {
        return false;
      }
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/Utils.js